// system/* 페이지 번역
const system = {
  management: {
    tabs: {
      general: '일반설정',
      monitoring: '모니터링설정',
      alarm: '알림설정',
      security: '보안설정',
      dataCollection: '데이터 수집관리',
      log: '시스템로그',
      ip: 'IP관리',
    },
    common: {
      save: '설정 저장',
      saving: '저장 중...',
      loading: '로딩 중...',
      refresh: '새로고침',
      saveSuccess: '설정이 저장되었습니다. 페이지를 새로고침합니다...',
      saveFailed: '설정 저장에 실패했습니다.',
      defaultSystemName: '사출 통합 관제 시스템',
    },
    general: {
      sectionBasic: '기본 정보',
      sectionContact: '연락처 정보',
      sectionBranding: '브랜딩',
      labels: {
        systemName: '시스템명',
        companyName: '회사명',
        companyCode: '회사코드',
        schemaName: '스키마명',
        businessNumber: '사업자등록번호',
        representativeName: '대표자명',
        contactEmail: '대표 이메일',
        contactPhone: '대표 연락처',
        address: '주소',
        logo: '로고',
        favicon: '파비콘',
      },
      placeholders: {
        contactEmail: 'example@company.com',
        contactPhone: '02-1234-5678',
        address: '서울시 강남구 테헤란로 123',
      },
      branding: {
        upload: '업로드',
        change: '변경',
        delete: '삭제',
        uploading: '업로드 중...',
        logoAlt: '로고 미리보기',
        faviconAlt: '파비콘 미리보기',
        hint: '지원 형식: JPG, PNG, GIF, SVG, ICO (최대 5MB)',
        logoUploadComplete: '로고 업로드 완료 (저장 시 적용)',
        faviconUploadComplete: '파비콘 업로드 완료 (저장 시 적용)',
        uploadFailed: '업로드 실패',
        fileUploadFailed: '파일 업로드에 실패했습니다.',
      },
    },
    monitoring: {
      sectionDashboard: '대시보드 설정',
      labels: {
        refreshInterval: '자동 새로고침 간격',
        timezone: '기준 시간',
      },
      refreshOptions: {
        onComplete: '데이터 수집완료 시',
        sec10: '10초',
        sec30: '30초',
        min1: '1분',
        min5: '5분',
        min10: '10분',
        disabled: '사용안함',
      },
      timezones: {
        seoul: '한국 표준시 (KST, UTC+9)',
        hochiminh: '베트남 표준시 (ICT, UTC+7)',
        utc: '협정 세계시 (UTC)',
        tokyo: '일본 표준시 (JST, UTC+9)',
        newyork: '미국 동부시 (EST/EDT)',
        london: '영국 표준시 (GMT/BST)',
      },
    },
    alarm: {
      sectionChannels: '알림 채널',
      sectionSound: '알람 소리',
      labels: {
        web: '웹 상단 알림',
        email: '이메일 알림',
        sms: 'SMS 알림',
        push: '웹 푸시 알림',
        sound: '알람 소리',
        mute: '음소거',
      },
      hints: {
        web: '웹 상단에 알림 메시지를 표시합니다',
        email: '등록된 이메일로 알림을 발송합니다 (연동 예정)',
        sms: '등록된 휴대폰으로 문자를 발송합니다 (연동 예정)',
        push: '브라우저 푸시 알림을 발송합니다 (연동 예정)',
        sound: '새 알람 발생 시 재생할 소리입니다 (이 브라우저에만 저장)',
        mute: '켜면 알람 소리를 재생하지 않습니다',
      },
      preview: '미리듣기',
      sounds: {
        single: '단일 비프 (삐)',
        double: '더블 비프 (삐-삐)',
        triple: '삐삐삐',
        chime: '차임',
        siren: '사이렌',
      },
      on: 'ON',
      off: 'OFF',
    },
    security: {
      sectionLogin: '로그인 보안',
      labels: {
        maxAttempts: '최대 로그인 실패 횟수',
        lockDuration: '계정 잠금 시간',
      },
      hints: {
        maxAttempts: '설정된 횟수만큼 로그인 실패 시 계정이 잠깁니다',
        lockDuration: '계정 잠금 후 자동 해제까지의 시간',
      },
      attempts: {
        n3: '3회',
        n5: '5회',
        n10: '10회',
      },
      duration: {
        m5: '5분',
        m10: '10분',
        m30: '30분',
        h1: '1시간',
        h24: '24시간',
      },
    },
    dataCollection: {
      sectionStatus: 'ETL 현재 상태',
      sectionDb: '데이터베이스 연결 상태',
      sectionHistory: '동기화 이력',
      cards: {
        runState: '실행 상태',
        lastRun: '마지막 실행',
        lastSuccess: '마지막 성공',
        recordsProcessed: '처리 레코드',
      },
      runState: {
        running: '실행 중',
        idle: '대기',
      },
      db: {
        rawName: 'Raw DB (MariaDB)',
        monitoringName: 'Monitoring DB (PostgreSQL)',
        connected: '연결됨',
        disconnected: '연결 실패',
        unknown: '확인 불가',
      },
      history: {
        col: {
          time: '동기화 시간',
          status: '상태',
          records: '처리 레코드',
          tables: '대상 테이블',
          note: '비고',
        },
        statusSuccess: '성공',
        statusFailed: '실패',
        empty: '동기화 이력이 없습니다',
      },
      actions: {
        refresh: '새로고침',
        manualSync: '수동 동기화',
        running: '실행 중...',
        inProgress: '동기화 진행중',
      },
      messages: {
        syncStarted: 'ETL 동기화가 시작되었습니다.',
        syncFailed: 'ETL 동기화 실행에 실패했습니다.',
      },
      recordsUnit: '{n}건',
    },
    log: {
      sectionHistory: '로그인/로그아웃 이력',
      filters: {
        all: '전체',
        login: '로그인',
        logout: '로그아웃',
        loginFailed: '로그인 실패',
      },
      col: {
        time: '시간',
        type: '유형',
        user: '사용자',
        email: '이메일',
        ip: 'IP 주소',
        note: '비고',
      },
      empty: '로그인 이력이 없습니다',
    },
  },
  ip: {
    notReady: {
      title: '서버 기능 준비 중',
      body: '접근 IP 제한은 아직 서버에 구현되지 않았습니다. 이 화면에서는 IP를 저장하거나 접속을 막을 수 없습니다.',
      empty: '등록된 IP가 없습니다',
    },
    controls: {
      addBtn: 'IP 추가',
    },
    table: {
      ip: 'IP 주소',
      description: '설명',
      access: '접근 권한',
      status: '상태',
      lastAccess: '최근 접속',
      createdAt: '등록일',
      createdBy: '등록자',
      actions: '작업',
    },
  },
};

export default system;
